/* ============================================================================
   RECETTAGE 2026-09-03 — POINT 17 : effet « le bloc blanc se rétracte »
   ----------------------------------------------------------------------------
   Repris du site FR : en fin de scroll, le bloc de contenu blanc se resserre
   légèrement sur les côtés et ses coins bas s'arrondissent, laissant apparaître
   le beige du footer derrière. L'effet s'estompe dès qu'on remonte.

   Choix d'implémentation (et pourquoi PAS les alternatives) :
   • pas de `clip-path` sur #MainContent : la barre d'ajout au panier collante
     (`sticky-add-cart`) est un `position: fixed` À L'INTÉRIEUR de #MainContent ;
     un clip-path sur un ancêtre la rendrait relative à cet ancêtre et casserait
     son ancrage bas d'écran.
   • pas d'`overflow: hidden` : ça ferait de #MainContent le conteneur de
     défilement et casserait tous les `position: sticky` de la fiche produit
     (galerie et colonne de droite).
   • pas de `will-change` / `backface-visibility` : interdits ici, ça casse le
     rendu des éléments fixes sur iOS Safari.
   Reste `margin-inline` + `border-radius`, arrondis au pixel pair pour ne
   déclencher qu'un nombre limité de recalculs de mise en page.
   ============================================================================ */
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;
  var footer = document.querySelector('.shopify-section-group-footer-group');
  if (!footer) return;

  var MAX_PULL = 34;   // retrait latéral max, en px
  var MAX_ROUND = 26;  // arrondi bas max, en px
  var last = -1;
  var ticking = false;

  function apply() {
    ticking = false;
    var vh = window.innerHeight || 800;
    if (vh < 520 || window.innerWidth < 700) {   // trop peu de place : pas d'effet
      if (last !== 0) { main.style.removeProperty('--shrink'); last = 0; }
      return;
    }
    var top = footer.getBoundingClientRect().top;
    // 0 quand le footer touche le bas de l'écran, 1 quand il est monté à 35% de la hauteur
    var p = (vh - top) / (vh * 0.65);
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    var step = Math.round(p * 100 / 6) * 6;      // paliers de 6% -> ~17 recalculs max
    if (step === last) return;
    last = step;
    var k = step / 100;
    main.style.setProperty('--shrink-pull', (MAX_PULL * k).toFixed(1) + 'px');
    main.style.setProperty('--shrink-round', (MAX_ROUND * k).toFixed(1) + 'px');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();
